<template>
  <article
    class="meal-article"
    :class="{ hoverable: clickable || updatable }"
    @click="onClick"
  >
    <p class="title" :style="computedStyle">{{ meal.title }}</p>
    <div v-if="meal.ingredients.length" class="ingredients-container">
      <div
        class="ingredient"
        v-for="(ingredient, index) in meal.ingredients"
        :key="index"
      >
        {{ ingredient.title || ingredient }}
      </div>
    </div>
  </article>
</template>

<script>
import _ from 'lodash';
import MealForm from '../Form/MealForm.vue';

export default {
  components: {},
  props: {
    meal: {
      type: Object,
      required: true,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    updatable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onClick() {
      if (this.clickable) {
        this.$emit('click', this.meal);
      } else if (this.updatable) {
        this.$modal.show(
          MealForm,
          {
            updateMeal: _.cloneDeep(this.meal),
          },
          {
            height: 'auto',
            width: this.isMediumScreen ? '95%' : '600px',
            clickToClose: true,
          }
        );
      }
    },
  },
  computed: {
    computedStyle() {
      const img = _.get(this.meal, 'img', null);
      return {
        backgroundImage: img
          ? `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${img})`
          : 'initial',
      };
    },
  },
};
</script>

<style lang="scss" scoped src="./Meal.scss"></style>
